import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import EditAddOnIndex from "../../../../components/SidetabPages/Catalog/Addon/EditAddOnIndex";

const AddOn = () => {
  return (
    <>
      <AnnouncementBar />
      <EditAddOnIndex />
    </>
  );
};
export default AddOn;
